/** Domain pattern catalogue — DP-01 through DP-05 per 07-11 */
export const DOMAIN_PATTERN_IDS = ['DP-01', 'DP-02', 'DP-03', 'DP-04', 'DP-05'] as const;

export type DomainPatternId = (typeof DOMAIN_PATTERN_IDS)[number];

export const DOMAIN_PATTERN_COMPONENTS: Record<DomainPatternId, string> = {
  'DP-01': 'OrderStatusChip',
  'DP-02': 'MoneyDisplay',
  'DP-03': 'AddressBlock',
  'DP-04': 'DateTimeDisplay',
  'DP-05': 'EmptyState',
};

export const EMPTY_STATE_VARIANTS = [
  'empty',
  'noMatch',
  'noPermission',
  'loadFailed',
  'partial',
  'offline',
] as const;

export type EmptyStateVariant = (typeof EMPTY_STATE_VARIANTS)[number];

/** Maps DP-05a–f to component variants */
export const EMPTY_STATE_DP_MAP: Record<EmptyStateVariant, string> = {
  empty: 'DP-05a',
  noMatch: 'DP-05b',
  noPermission: 'DP-05c',
  loadFailed: 'DP-05d',
  partial: 'DP-05e',
  offline: 'DP-05f',
};
